<template>
  <div class="mydialog">
    <div class="page_title">介绍审核</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo noneline"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item
                index="2"
                class="title"
                style="font-size: 16px"
              >待审核</el-menu-item>
              <el-menu-item
                index="3,4"
                class="title space"
                style="font-size: 16px"
              >已审核</el-menu-item>
            </el-menu>
          </div>
          <div class="box">
            <div class="searchbox flex">
              <span>药房名称</span>
              <el-input
                v-model="hospital_name"
                style="width: 120px; margin: 0 20px 0 10px"
                @input="search"
                clearable
              ></el-input>
              <span>药房类型</span>
              <el-select
                v-model="org_type"
                placeholder="请选择"
                style="width: 160px; margin: 0 20px 0 10px"
                @change="search"
              >
                <el-option
                  v-for="item in org_type_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span>提交时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 264px; margin: 0 12px"
                @change="
                  (value) => {
                    return search(value, 1);
                  }
                "
              ></el-date-picker>

              <el-button
                type="info"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-right: 15px;
                "
                @click="search"
              >查询</el-button>
              <el-button
                type="primary"
                @click="examineAll"
                style="width: 120px; margin-left: auto"
                v-show="active == 1"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('96') : false
                "
              >批量审核</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection"></el-table-column>

                <el-table-column
                  label="药房名称"
                  prop="hospital_name"
                ></el-table-column>
                <el-table-column
                  label="药房类型"
                  prop="org_type"
                ></el-table-column>
                <el-table-column
                  label="物流说明"
                  prop="logistics_desc"
                ></el-table-column>
                <el-table-column
                  label="提交日期"
                  prop="create_time"
                >
                  <template slot-scope="scope">
                    <div>{{ scope.row.create_time }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.reviewed_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('263')
                          : false
                      "
                    >查看详情</el-button>
                    <el-button
                      type="text"
                      @click="examine(scope.row.reviewed_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('262')
                          : false
                      "
                    >审核</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      Selection: [],
      activeIndex: '2',
      active: 2,
      hospital_name: '',
      org_type: 0,
      org_type_list: [
        { label: '全部', value: 0 },
        { label: '单体药店', value: 1 },
        { label: '医疗机构药房', value: 2 }
      ],
      date: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取审核列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name,
        org_type: this.org_type,
        auth_status: this.active,
        start_time: this.date.length
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/hospital/getHospitalDescAuthList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = moment
                .unix(item.create_time)
                .format('YYYY-MM-DD');
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelect(key, keyPath) {
      this.hospital_name = '';
      (this.org_type = 0), (this.active = key);
      this.currentPage = 1;
      this.pagesize = 10;
      this.date = [];
      this.getList();
    },
    search(value, status) {
      if (status) {
        if (!value) {
          this.date = [];
        }
      }
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChange(val) {
      this.Selection = val;
    },

    //药房详情
    toDetail(reviewed_id) {
      this.$router.push({ path: 'jieshaodetail', query: { reviewed_id } });
    },
    //审核
    examine(reviewed_id) {
      this.$confirm('是否审核通过？', '审核', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过'
      })
        .then(() => {
          let auth_status = 3;
          let data = { reviewed_id, auth_status };
          this.axios
            .post('platform/hospital/auditHospitalDesc', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('介绍审核通过!');
              }
              this.getList();
            });
        })
        .catch((action) => {
          if (action === 'cancel') {
            let auth_status = 4;
            let data = { reviewed_id, auth_status };
            this.axios
              .post('platform/hospital/auditHospitalDesc', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.error('介绍审核未通过!');
                }
                this.getList();
              });
          }
        });
    },
    //批量审核
    examineAll() {
      if (!this.Selection.length) {
        this.$message.error("请勾选'审核中'的记录");
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.reviewed_id;
      });
      let reviewed_id = selectId.toString();
      this.examine(reviewed_id);
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>